import React, { createContext, useContext, useState, ReactNode } from "react";

interface PrefillContextType {
  isPrefilling: boolean;
  setIsPrefilling: (value: boolean) => void;
}

const PrefillContext = createContext<PrefillContextType | undefined>(undefined);

export const PrefillProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isPrefilling, setIsPrefilling] = useState(false);

  return (
    <PrefillContext.Provider value={{ isPrefilling, setIsPrefilling }}>
      {children}
    </PrefillContext.Provider>
  );
};

export const usePrefillContext = () => {
  const context = useContext(PrefillContext);
  if (context === undefined) {
    throw new Error("usePrefillContext must be used within a PrefillProvider");
  }
  return context;
};
